import React, { useContext } from 'react'
import styled from 'styled-components'
import { Box, Button, Card, Flex, Text } from 'pcln-design-system'
import { Content } from '@pcln/ace-content-react'
import { WebPBackgroundImage } from '@pcln/content-tile'
import { LogoPricelineVip } from '@pcln/vip'
import { BootstrapDataContext } from '../../../contexts'
import constants from './constants'
import * as PCLNAnalytics from '../../../utils/PCLN-Analytics'

const ImageWrapper = styled(Flex)`
  ${props => props.theme.mediaQueries[0]} {
    flex: 1 1 50%
  }
  ${props => props.theme.mediaQueries[3]} {
    flex: 1 1 33%
  }
`

const StyledWebP = styled(WebPBackgroundImage)`
  background-color: transparent;
  background-position: center;
  background-size: 125%;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  height: 109px;
  width: 100%;
  ${props => props.theme.mediaQueries[0]} {
    background-size: 100%;
  }
  ${props => props.theme.mediaQueries[3]} {
    background-size: auto 130%;
    border-bottom-left-radius: 4px;
    border-top-right-radius: 0;
    height: inherit;
  }
`

const PromoWrapper = styled(Card)`
  background-color: white;
  height: 298px;
  ${props => props.theme.mediaQueries[0]} {
    height: 340px;
  }
  ${props => props.theme.mediaQueries[3]} {
    height: 250px;
  }
`

const StyledBox = styled(Box)`
  width: 100%;
  ${props => props.theme.mediaQueries[3]} {
    width:  66%;
  }
`

const StyledLogoPricelineVip = styled(LogoPricelineVip)`
  font-size: 32px;
  height: 32px;
  line-height: 1;
  margin-bottom: 8px;
  ${props => props.theme.mediaQueries[3]} {
    font-size: 48px;
    height: 48px;
  }
`

const handleClick = (isSignedIn: boolean) => {
  PCLNAnalytics.send({
    action: 'Feature Box CTA',
    category: 'PCLN_HOME',
    data: isSignedIn ? 'Vip Black Friday Sign Up' : 'Black Friday Sign Up'
  })
  window.open('/blackfriday', '_blank')
}

const BlackFridayPromo = () => {
  const {
    isMobile,
    signInStatus = { signedIn: false, passiveSignIn: false }
  } = useContext(BootstrapDataContext)

  const isSignedIn = signInStatus.signedIn || signInStatus.passiveSignIn
  const headlineKey = isSignedIn ? 'B991339B0B' : '5B9BA79BBA'
  const subHeadlineKey = isSignedIn ? '35BFA7A925' : '88A789829B'
  const buttonKey = isSignedIn ? '8863C8AB99' : 'B8BB0AB869'
  const subHeadlineFallback = isSignedIn ? 'Make sure you’re signed up to receive emails about early access to our Black Friday & Cyber Monday sale!' : 'Become an email insider to receive access to our Black Friday offers!'
  const signedInTop = isMobile ? '8px' : '16px'
  const signedOutTop = isMobile ? '22px' : '52px'

  return (
    <PromoWrapper
      boxShadowSize={['sm', null, 'md']}
      borderRadius='4px'
      mt={['24px', null, 0]}
      mx={[0, null, 2]}
      width={[1, null, 2 / 3]}
    >
      <Flex
        flexDirection={['column', null, null, null, 'row']}
        style={{ height: '100%' }}
        width={1}
      >
        <ImageWrapper>
          <StyledWebP
            image={isMobile ? constants.blackFriday.mobileImage : constants.blackFriday.image}
            imageWebP={isMobile ? constants.blackFriday.mobileImageWebP : constants.blackFriday.imageWebP}
          />
        </ImageWrapper>
        <StyledBox
          pb={3}
          pt={isSignedIn ? signedInTop : signedOutTop}
          px={3}
          height={['189px', null, '100%']}
        >
          {isSignedIn && <StyledLogoPricelineVip variation='vip' />}
          <Flex
            flexDirection='column'
            mb={[
              isSignedIn ? '9px' : '31px',
              null,
              null,
              isSignedIn ? '30px' : '44px',
              isSignedIn ? '15px' : null,
              isSignedIn ? '30px' : null
            ]}
          >
            <Text
              color='text'
              fontSize={[2, null, null, '22px', 4]}
              fontWeight='bold'
              lineHeight={['22px', null, '33px']}
              mb={2}
            >
              <Content name={[headlineKey]} fallback='Are you ready?' />
            </Text>
            <Text
              color='text'
              fontSize={[0, null, 1]}
              lineHeight={['17px', null, '19px']}
            >
              <Content name={[subHeadlineKey]} fallback={subHeadlineFallback} />
            </Text>
          </Flex>
          <Button
            aria-label='black friday promo button'
            onClick={() => handleClick(isSignedIn)}
            size={isMobile ? 'medium' : 'large'}
            width={['116px', null, '157px']}
          >
            <Content name={[buttonKey]} fallback={'Sign Up'} />
          </Button>
        </StyledBox>
      </Flex>
    </PromoWrapper>
  )
}

export default BlackFridayPromo
